// The guided tour of the Application Catalogue, for the support team meeting
// it for the first time after the SharePoint Application Wiki.
//
// Steps point at [data-tour] anchors on ApplicationCataloguePage's list view,
// in the order the page reads: header, tiles, filters, the table, then adding
// an application. The engine (shared/FeatureTour.jsx) and the show-once record
// (hooks/useFeatureTour.js) are generic; only this file knows about versions.

export const APPLICATION_CATALOGUE_TOUR_ID = 'application-catalogue';

export const applicationCatalogueTourSteps = [
  {
    title: 'The Application Catalogue',
    target: '[data-tour="page-header"]',
    body: [
      'Every application Alton Valley supports now lives here rather than on the SharePoint wiki: the version we run, the version the vendor ships, who owns it, and when security support runs out.',
      'Use Next (or the arrow keys) to walk through, or Skip if you would rather explore. Either way it will not pop up again.',
    ],
  },
  {
    title: 'What needs attention',
    target: '[data-tour="summary-tiles"]',
    body: [
      'The tiles count the catalogue by state: how many are up to date, how many are behind the latest release, how many lose support within 90 days, and how many are already past end of life.',
    ],
  },
  {
    title: 'Find an application',
    target: '[data-tour="filters"]',
    body: [
      'Search by name, vendor or owner, or narrow the table to one criticality or one support status.',
    ],
  },
  {
    title: 'Installed, latest, and how long support lasts',
    target: '[data-tour="catalogue-table"]',
    body: [
      'Installed is the lowest version across the servers the application runs on. Latest comes from endoflife.date overnight, or from whoever maintains the entry by hand. Rows tinted red are past end of life; amber rows lose support within 90 days.',
      'Open a row for the application page: its release cycles, every server it runs on, the patch history, and the contacts. Log a patch from there once one is applied; the flag clears when every server is on a supported release.',
    ],
  },
  {
    title: 'Add an application',
    target: '[data-tour="add-application"]',
    body: [
      'Add anything you support: name, vendor, criticality and owners first, then the servers it runs on. Under Version tracking on its page, pick the endoflife.date product so the latest release and end-of-life dates refresh themselves, or enter them by hand for a vendor with no feed.',
      'The business owner or SME can be anyone: start typing and our own people are offered as completions, or write in a name from the client or the vendor. Owners at Alton Valley are emailed 90, 30 and 0 days before support ends, then weekly while it stays past end of life, and the bell in the header shows the same alerts. Somebody outside Alton Valley is recorded as the owner but not emailed.',
    ],
  },
];
